// extracted by css-extract-rspack-plugin
export default {"cls1":"Reader-cls1_ZFC","cls2":"Reader-cls2_i5B Reader-cls1_ZFC","fullWidthCoreX":"Reader-fullWidthCoreX_ffM"};